// https://www23.statcan.gc.ca/imdb/p3VD.pl?Function=getVD&TVD=141329
export var THREE_LETTER_EU_COUNTRY_CODES = {
    AUT: "AUT",
    BEL: "BEL",
    BGR: "BGR",
    CYP: "CYP",
    CZE: "CZE",
    DEU: "DEU",
    DNK: "DNK",
    ESP: "ESP",
    EST: "EST",
    FIN: "FIN",
    FRA: "FRA",
    GRC: "GRC",
    HRV: "HRV",
    HUN: "HUN",
    IRL: "IRL",
    ITA: "ITA",
    LTU: "LTU",
    LUX: "LUX",
    LVA: "LVA",
    MLT: "MLT",
    NLD: "NLD",
    POL: "POL",
    PRT: "PRT",
    ROU: "ROU",
    SVK: "SVK",
    SVN: "SVN",
    SWE: "SWE"
};
